import '@vkontakte/vkui/dist/components.css';
import { createRoot } from 'react-dom/client';
import { App } from './app';
import { ErrorBoundary } from './shared/ui';
import { ErrorPage } from './pages/ErrorPage';
import './fonts.css';

async function main() {
  const container = document.getElementById('root');
  const root = createRoot(container!);

  root.render(
    <ErrorBoundary fallback={(retry) => <ErrorPage onRetry={retry} />}>
      <App />
    </ErrorBoundary>,
  );
}

main();
